var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_block" },
    [
      _c("el-pagination", {
        attrs: {
          "current-page": Number(_vm.currentPage),
          "page-size": Number(_vm.pageSize),
          "page-sizes": _vm.pageSizes,
          total: Number(_vm.totalNumber),
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }